import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";
import numberFormatter from "utils/numberFormatter";

import {
  ChildSectionTitle,
  SideLabelTextAreaWithRefInput,
  SideLabelMoneyInput,
  SideLabelCalculatedField
} from "../FormSectionComponents";

const InsuranceGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;
class InsuranceSection extends React.Component {
  render() {
    const { isEditing } = this.props;

    return (
      <div id="loan_section_insurance" style={{ paddingBottom: "20px" }}>
        <ChildSectionTitle>Insurance</ChildSectionTitle>
        <InsuranceGrid container alignItems="center" direction="column">
          <SideLabelTextAreaWithRefInput
            label="Mandatory Prepayments"
            hasBorder
            placeholder="Mandatory Prepayments"
            fieldName="insurance.mandatoryPrePayments"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Restoration"
            hasBorder
            placeholder="Restoration"
            fieldName="insurance.restoration"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Required Policies"
            hasBorder
            placeholder="Required Policies"
            fieldName="insurance.requiredPolicies"
            isDisabled={!isEditing}
          />

        </InsuranceGrid>
      </div>
    );
  }
}
export default InsuranceSection;
